/** @format */

import dayjs, { Dayjs } from 'dayjs'
import { _$ } from '@king-design/react'

// 快捷选择日期范围key
enum RANGE_CONFIG_ENUM {
  '近5分钟' = '近5分钟',
  '近0.5小时' = '近0.5小时',
  '近1小时' = '近1小时',
  '近3小时' = '近3小时',
  '近1天' = '近1天',
  '近3天' = '近3天',
  '近1周' = '近1周',
  '近30天' = '近30天'
}

type IQicekRange = keyof typeof RANGE_CONFIG_ENUM

export const date_range_config = {
  [RANGE_CONFIG_ENUM['近5分钟']]: '5min',
  [RANGE_CONFIG_ENUM['近0.5小时']]: '0.5h',
  [RANGE_CONFIG_ENUM['近1小时']]: '1h',
  [RANGE_CONFIG_ENUM['近3小时']]: '3h',
  [RANGE_CONFIG_ENUM['近1天']]: '1day',
  [RANGE_CONFIG_ENUM['近3天']]: '3day',
  [RANGE_CONFIG_ENUM['近1周']]: '1week',
  [RANGE_CONFIG_ENUM['近30天']]: '30day'
}
export const quick_range_config = {
  '5min': [RANGE_CONFIG_ENUM['近5分钟']],
  '0.5h': [RANGE_CONFIG_ENUM['近0.5小时']],
  '1h': [RANGE_CONFIG_ENUM['近1小时']],
  '3h': [RANGE_CONFIG_ENUM['近3小时']],
  '1day': [RANGE_CONFIG_ENUM['近1天']],
  '3day': [RANGE_CONFIG_ENUM['近3天']],
  '1week': [RANGE_CONFIG_ENUM['近1周']],
  '30day': [RANGE_CONFIG_ENUM['近30天']]
}

// 根据快捷选择 匹配 日期
export const getRangeDateValue = (key: string): [number, number] => {
  switch (key) {
    case date_range_config['近5分钟']:
      return [dayjs().subtract(5, 'minute').valueOf(), dayjs().valueOf()]
    case date_range_config['近0.5小时']:
      return [dayjs().subtract(30, 'minute').valueOf(), dayjs().valueOf()]
    case date_range_config['近1小时']:
      return [dayjs().subtract(1, 'hour').valueOf(), dayjs().valueOf()]
    case date_range_config['近3小时']:
      return [dayjs().subtract(3, 'hour').valueOf(), dayjs().valueOf()]
    case date_range_config['近1天']:
      return [dayjs().subtract(1, 'day').valueOf(), dayjs().valueOf()]
    case date_range_config['近3天']:
      return [dayjs().subtract(3, 'day').valueOf(), dayjs().valueOf()]
    case date_range_config['近1周']:
      return [dayjs().subtract(7, 'day').valueOf(), dayjs().valueOf()]
    case date_range_config['近30天']:
      return [dayjs().subtract(30, 'day').valueOf(), dayjs().valueOf()]
    default:
      // 默认近0.5小时
      return [dayjs().subtract(30, 'minute').valueOf(), dayjs().valueOf()]
  }
}

// 根据日期 匹配 快捷选择
export const getRangeDateShortcuts = (date: [number, number]) => {
  const [start, end] = date
  if (dayjs().diff(dayjs(end), 's') <= 60) {
    const diff = dayjs(end).diff(dayjs(start), 's')
    switch (diff) {
      case 300:
        return date_range_config['近5分钟']
      case 1800:
        return date_range_config['近0.5小时']
      case 3600:
        return date_range_config['近1小时']
      case 10800:
        return date_range_config['近3小时']
      case 86400:
        return date_range_config['近1天']
      case 259200:
        return date_range_config['近3天']
      case 604800:
        return date_range_config['近1周']
      case 2592000:
        return date_range_config['近30天']
      default:
        return ''
    }
  } else {
    return ''
  }
}

type IDateValueType = IQicekRange | [Date, Date] | [string, string] | [number, number]

export const renderShortcuts: { label: () => string; value: () => [Date, Date] }[] = [
  {
    label: function label() {
      return _$('本周')
    },
    value: function value() {
      return [dayjs().startOf('week').toDate(), dayjs().toDate()]
    }
  },
  {
    label: function label() {
      return _$('上一周')
    },
    value: function value() {
      return [
        dayjs().subtract(1, 'weeks').startOf('week').toDate(),
        dayjs().subtract(1, 'weeks').endOf('week').toDate()
      ]
    }
  },
  {
    label: function label() {
      return _$('本月')
    },
    value: function value() {
      return [dayjs().startOf('months').toDate(), dayjs().toDate()]
    }
  },
  {
    label: function label() {
      return _$('上一个月')
    },
    value: function value() {
      return [
        dayjs().subtract(1, 'months').startOf('months').toDate(),
        dayjs().subtract(1, 'months').endOf('months').toDate()
      ]
    }
  }
]

export interface IQuickRangeDateProps {
  className?: string
  defautlValue?: IDateValueType
  changeValue: (value: [number, number] | [], quick: string) => void
  quickRange?: Array<IQicekRange> // 快捷选择按钮
  showQucikBtn?: boolean
  optionalRange?: number // 可选范围
  optionalMaxDate?: Dayjs // 最大可以选择范围（默认为当前时间）
  optionalDateRange?: number // 最小可选范围（距离optionalMaxDate多少天）
  realoadIcon?: boolean // 是否有重置icon
  dateDiff?: number // 开始/结束时间差
  showShortcuts?: boolean
  width?: string
  [key: string]: any
}
